import { render, staticRenderFns } from "./WebTwoTrainReport.vue?vue&type=template&id=86eb1ba8&scoped=true&"
import script from "./WebTwoTrainReport.vue?vue&type=script&lang=js&"
export * from "./WebTwoTrainReport.vue?vue&type=script&lang=js&"
import style0 from "./WebTwoTrainReport.vue?vue&type=style&index=0&id=86eb1ba8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86eb1ba8",
  null
  
)

export default component.exports